import React from 'react';
import { debounce } from 'lodash';
import { InputBase } from '@mui/material';
import { useEffect, useState } from 'react';

const debouncedUpdate = debounce((updatedValueString, onChange) => onChange(updatedValueString), 200);

// Updated from original monorepo common-client2 component
const DebouncedInputBase = ({ onChange, value, ...others }) => {
    const [displayedValue, setDisplayedValue] = useState(value);
    const onValueChange = (ev, changedValue) => {
        debouncedUpdate(ev.target.value, onChange);
        setDisplayedValue(changedValue);
    };

    useEffect(() => setDisplayedValue(value), [value]);
    return (
        <InputBase
            onChange={onValueChange}
            value={displayedValue}
            {...others}
        />
    );
};

export default DebouncedInputBase;
